export default __webpack_public_path__ + "media/images/client-logos/clc-logo-07b0f149581d130e7f86ca33904845b9.png";